// extracted by mini-css-extract-plugin
export default {"a11yFocus":"J0yB6x","a11YFocus":"J0yB6x","submitButton":"Mrg5fW","logo":"HmOhsD","centered":"zxeHZc","secondaryLogo":"Exvxqr"};